module.exports = __webpack_public_path__ + "media/images/t-logo-5de74319ac840ee3a8902d8147b5997f.png";